import { Avatar, Stack, Tooltip } from '@mui/material'
import { Exchange, exchangeToJSON } from '../../proto/generated/common'

/** Static exchange marks served from public/images/exchanges/{nse,bse}.svg. */
export const exchangeLogoUrl = (exchange: Exchange): string | undefined => {
    switch (exchange) {
        case Exchange.NSE:
            return '/images/exchanges/nse.svg'
        case Exchange.BSE:
            return '/images/exchanges/bse.svg'
        default:
            return undefined
    }
}

interface ExchangeLogosProps {
    exchanges: Exchange[]
    size?: number
}

/**
 * Small exchange logos, stacked with a slight overlap when there is more than one - the same
 * treatment the news widget uses for company logos.
 */
const ExchangeLogos = ({ exchanges, size = 16 }: ExchangeLogosProps) => {
    const unique = exchanges.filter((e, i) => exchanges.indexOf(e) === i && exchangeLogoUrl(e))
    if (unique.length === 0) return null
    return (
        <Stack direction="row" alignItems="center" sx={{ position: 'relative', flexShrink: 0 }}>
            {unique.map((exchange, i) => (
                <Tooltip key={exchange} title={exchangeToJSON(exchange)} arrow>
                    <Avatar
                        alt={exchangeToJSON(exchange)}
                        src={exchangeLogoUrl(exchange)}
                        sx={{
                            width: size,
                            height: size,
                            border: (theme) => `1px solid ${theme.palette.background.paper}`,
                            position: 'relative',
                            zIndex: unique.length - i,
                            marginLeft: i === 0 ? 0 : '-5px',
                            bgcolor: 'transparent'
                        }}
                    />
                </Tooltip>
            ))}
        </Stack>
    )
}

export default ExchangeLogos
